const napaTheme = {
  palette: {
    primary: {
      main: "#006F35",
    },
    secondary: {
      main: "#326eb3",
    },
  },
  colors: {
    green: "#006F35",
    red: "#EA0000",
    warning: "#E68500",
    greenbg: "#006F352F",
    lightgrey: "#B1B1B1",
    darkgrey: "#848484",
    darkestgrey: "#5e5e5e",
    title: "#707070;",
    white: "#FFFF",
    background: "#FFFF",
    headergrey: "#EDEDED",
  },
  transitions: {
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      // most basic recommended timing
      standard: 300,
      // this is to be used in complex animations
      complex: 375,
      // recommended when something is entering screen
      enteringScreen: 225,
      // recommended when something is leaving screen
      leavingScreen: 195,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  spacing: [0, 4, 8, 16, 32, 64],
};


export default napaTheme;
